import Icon from '../components/Icon.vue'

Icon.register({
  divide: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224 352C188.7 352 160 380.6 160 416S188.7 480 224 480 288 451.4 288 416 259.4 352 224 352zM224 160C259.4 160 288 131.4 288 96S259.4 32 224 32 160 60.6 160 96 188.7 160 224 160zM416 208H32C14.3 208 0 222.3 0 240V272C0 289.7 14.3 304 32 304H416C433.7 304 448 289.7 448 272V240C448 222.3 433.7 208 416 208z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/divide.js
// module id = 79fQ
// module chunks = 144